import * as React from 'react';
import { lazy } from 'react';
import type { RouteProps } from 'react-router-dom';

const ProductDetail = lazy(() => import('./index'));

/** 路由配置 */
export const routeConfig: RouteProps[] = [
  {
    path: '/productDetail',
    element: <ProductDetail />,
  },
];
